import { unstable_createMemoryUploadHandler, unstable_parseMultipartFormData } from "@remix-run/cloudflare";
import { useFetcher } from "@remix-run/react";
import { useCallback, useEffect } from "react";
import type { action } from "~/routes/uploadToR2";
import { v4 as uuidv4 } from "uuid";

export const uploadFileToR2 = async (
  R2: R2Bucket,
  request: Request, name: string,
  r2UpId?: string,
  auth: boolean = false
) => {
  r2UpId = r2UpId || uuidv4()

  const uploadHandler = unstable_createMemoryUploadHandler({
    maxPartSize: 1024 * 1024 * 100,
  });
  const form = await unstable_parseMultipartFormData(request, uploadHandler);
  // ここまでなんか必要な処理

  const file = form.get(name) as Blob;
  const authKey = auth ? uuidv4() : null
  const response = await R2.put(r2UpId, await file.arrayBuffer(), {
    httpMetadata: {
      contentType: file.type,
    },
    customMetadata: authKey ? {
      authKey
    } : {}
  })
  return { response, authKey, r2UpId };
}


export const useUpload = (
  setThumnailPath: (path: string) => void,
) => {
  const fetcher = useFetcher<typeof action>();

  useEffect(() => {
    if (fetcher.state === "idle" && fetcher.data?.object.key) {
      setThumnailPath(fetcher.data?.object.key);
    }
  }, [fetcher, setThumnailPath]);

  const imageSelect = useCallback(
    async (file: File) => {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        fetcher.submit(formData, {
          method: "post",
          action: "/uploadToR2",
          encType: "multipart/form-data",
        });
      }
    },
    [fetcher],
  );
  return { imageSelect };
};
